import { render, staticRenderFns } from "./main.layout.vue?vue&type=template&id=bb30abba&scoped=true"
import script from "./main.layout.vue?vue&type=script&lang=js"
export * from "./main.layout.vue?vue&type=script&lang=js"
import style0 from "./main.layout.vue?vue&type=style&index=0&id=bb30abba&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb30abba",
  null
  
)

export default component.exports